import { useState, useEffect, useCallback } from 'react';
import { api, type Subscription } from '@/lib/api';

export function useSubscription() {
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setError(null);
      const sub = await api.getSubscription();
      setSubscription(sub);
    } catch (e) {
      console.error('[useSubscription] refresh failed:', e);
      setError(e instanceof Error ? e.message : 'サブスクリプション取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const isPremium = subscription?.premium === true;
  const remaining = typeof subscription?.remaining === 'number' ? subscription.remaining : 10;
  const monthlyCount = typeof subscription?.monthlyCount === 'number' ? subscription.monthlyCount : 0;
  const limit = typeof subscription?.limit === 'number' ? subscription.limit : 10;

  // 時間ベース制限（負値/NaN防御）
  const toNonNeg = (v: unknown, fallback: number) =>
    Number.isFinite(v as number) ? Math.max(0, Math.floor(v as number)) : fallback;
  const monthlySeconds = toNonNeg(subscription?.monthlySeconds, 0);
  const limitSeconds = toNonNeg(subscription?.limitSeconds, 600);
  const remainingSeconds = toNonNeg(subscription?.remainingSeconds, 600);

  return {
    subscription, isPremium, remaining, monthlyCount, limit,
    monthlySeconds, limitSeconds, remainingSeconds,
    loading, error, refresh,
  };
}
